import { render, staticRenderFns } from "./VideoDirectorConfigRecorderEdit.vue?vue&type=template&id=6cb3ecb8&"
import script from "./VideoDirectorConfigRecorderEdit.vue?vue&type=script&lang=js&"
export * from "./VideoDirectorConfigRecorderEdit.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports